<template>
    <BreadCrumb PageTitle="Liste des marques" />
    <ListeMarque/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import ListeMarque from "../../../components/Ecommerce/Marque/ListeMarque.vue";

    export default defineComponent({
      name: "ListeMarquePage",
      components: {
        BreadCrumb,
        ListeMarque,
      },
    });
  </script>